export default "__VITE_ASSET__CFo2BDIS__$_?url__"